import React from "react";
import AdminManagementTable from "./components/AdminManagementTable";

function Tables() {
  return <AdminManagementTable />;
}

export default Tables;
